import { Button } from '@servicecompressionllc/sc-design-system';
import { Shield } from '@servicecompressionllc/sc-design-system/icons';

/**
 * Zero-documents state. The example box is the whole point of this card — the
 * common failure is uploading a policy manual instead of a constraint catalog,
 * so the shape of one rule is shown before any button is offered.
 */
export const GuardrailsFirstRun = ({
  onAddRule,
  onUpload,
  onDownloadTemplate,
}: {
  onAddRule: () => void;
  onUpload: () => void;
  onDownloadTemplate: () => void;
}) => (
  <div className="border-outline bg-surface-elevated mt-6 rounded-2xl border p-9 text-center shadow-sm">
    <span className="bg-info-soft text-info mx-auto mb-4 grid h-12 w-12 place-items-center rounded-xl">
      <Shield size={24} aria-hidden />
    </span>
    <h3 className="text-ink mb-1.5 text-lg font-bold">No guardrail documents yet</h3>
    <p className="text-ink-muted mx-auto mb-5 max-w-[62ch] text-sm leading-relaxed">
      Guardrails are <b className="text-ink font-semibold">rules, not manuals</b> — upload a
      constraint catalog, not your full policy library. Each rule states a situation, what the
      assistant must never instruct, and what to do instead:
    </p>

    <div className="border-danger bg-surface mx-auto mb-6 max-w-[640px] space-y-1 rounded-r-lg border-l-2 p-3.5 text-left">
      <p className="text-ink text-[13px] leading-snug">
        <span className="text-ink-subtle text-[11px] font-bold tracking-wide">
          WHEN HELPING WITH
        </span>{' '}
        — clearing a jam or turning equipment by hand
      </p>
      <p className="text-ink text-[13px] leading-snug">
        <span className="text-ink-subtle text-[11px] font-bold tracking-wide">NEVER INSTRUCT</span>{' '}
        — reaching near any assembly that could start or turn
      </p>
      <p className="text-ink text-[13px] leading-snug">
        <span className="text-ink-subtle text-[11px] font-bold tracking-wide">INSTEAD</span> —
        confirm lockout before reaching in ·{' '}
        <span className="text-ink-subtle text-[11px] font-bold tracking-wide">AUTHORITY</span> —
        SOP1006
      </p>
    </div>

    <div className="flex flex-wrap items-center justify-center gap-2.5">
      <Button onClick={onAddRule}>New rule</Button>
      <Button variant="secondary" onClick={onUpload}>
        Upload document
      </Button>
      <Button variant="ghost" onClick={onDownloadTemplate}>
        Download template
      </Button>
    </div>
  </div>
);
